import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-single-tag',
  templateUrl: './single-tag.component.html',
  styleUrls: ['./single-tag.component.css']
})
export class SingleTagComponent implements OnInit {
  @Input() tag: string;
  @Input() selected: boolean;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/tags/single-tag/single-tag.component.ts